
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's02c72eca8096d52b': `Fréquence :`,
's061681af0ef72b5b': `Source : RCP`,
's07b491eb0576ebe7': `Fréquent`,
's0a0128aa069c7079': `MÉDICAMENTS`,
's2275181e03237a7d': `Choisir la fréquence.`,
's239412ba24c41c3d': `EFFETS INDÉSIRABLES`,
's4f98e3dc95342d4b': `APPAREIL`,
's5bc631044823f152': `Inconnue`,
's66816dfbf0e7ecb1': `Peu fréquent`,
's6c4f34936917c922': `Choisir le niveau d'affichage.`,
's6cac4d926f758862': `Très rare`,
's7ac2ed2b6e85c444': `Il n'y a pas d'effets indésirables dont les fréquences sont : `,
's9834072bd350f59d': `Rare`,
's9cf567bc9eccb5b4': `Très fréquent`,
's9dfd349c32ba726b': `Réinitialiser le niveau d'affichage.`,
'scd2231ae377afdd4': `Niveau d'affichage courant.`,
'se7692ace93a23c21': `Exceptionnel`,
'sf8cdcbf29ee05fbd': `Cas isolés`,
    };
  